<template>
  <v-card
    class="mx-auto"
    outlined
  >
    <form>
      <v-row
        no-gutters
        class="px-4"
      >
        <v-col
          cols="12"
          class="px-3 py-3"
          :sm="12"
        >
          <v-card-title class="headline">
            Meeting point
          </v-card-title>
        </v-col>
        <v-col
          cols="12"
          class="px-3"
          :sm="12"
        >
          <v-textarea
            v-model="meetingPoint.description"
            outlined
            :error-messages="descriptionErrors"
            required
            @input="$v.meetingPoint.description.$touch()"
            @blur="$v.meetingPoint.description.$touch()"
          >
            <template v-slot:label>
              <div>
                Описание
              </div>
            </template>
          </v-textarea>
        </v-col>
        <v-col
          cols="12"
          class="px-3"
          :sm="12"
          :md="6"
        >
          <v-text-field
            v-model="meetingPoint.coordinate.longitude"
            outlined
            label="Долгота (37.xxxxxx)"
            required
          />
        </v-col>
        <v-col
          cols="12"
          class="px-3"
          :sm="12"
          :md="6"
        >
          <v-text-field
            v-model="meetingPoint.coordinate.latitude"
            outlined
            label="Широта (55.xxxxxx)"
            required
          />
        </v-col>
        <v-col
          cols="12"
          class="px-3"
          :sm="12"
        >
          <v-autocomplete
            v-model="meetingPoint.metroStationList"
            :items="metroStationList"
            return-object
            multiple
            outlined
            item-value="id"
            item-text="title"
            label="Станции метро"
          >
            <template v-slot:selection="data">
              <v-chip
                v-bind="data.attrs"
                :input-value="data.selected"
                close
                outlined
                :color="data.item.line.color || 'success'"
                @click="data.select"
                @click:close="removeMetroStation(data.item)"
              >
                <span :style="{color: data.item.line.color || undefined}">
                  {{ data.item.title }}
                </span>
              </v-chip>
            </template>
            <template v-slot:item="data">
              <span>
                <span
                  class="metro-point"
                  :style="{backgroundColor: data.item.line.color || undefined}"
                />
                {{ data.item.title }}
              </span>
            </template>
          </v-autocomplete>
        </v-col>
        <v-col
          cols="12"
          class="px-3"
          :sm="12"
        >
          <v-btn
            color="success"
            left
            small
            @click="onPickFile({
              loadedEvent: eventNames.MEET_POINT_FILE_LOADED,
              deleteEvent: eventNames.MEET_POINT_DELETE_FILE,
              key: meetingPoint.office.id}
            )"
          >
            {{ 'add_files' | trans }}
          </v-btn>
          <FileForm
            ref="docForm"
            :files="meetingPoint.fileList"
            :idx="meetingPoint.office.id"
          />
        </v-col>
        <v-col
          cols="12"
          class="px-3"
          :sm="12"
        >
          <FileList
            :delete-event="eventNames.MEET_POINT_DELETE_FILE"
            :files="meetingPoint.fileList"
          />
        </v-col>
      </v-row>
    </form>
    <v-card-actions>
      <v-btn
        text
        outlined
        rounded
        color="success"
        class="ml-6 my-4"
        @click="submit"
      >
        Сохранить
      </v-btn>
      <v-btn
        v-if="office.status !== 'active'"
        color="success"
        text
        @click="activeOffice(office)"
      >
        Активировать объект
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import DictionaryMixin from '@/mixins/dictionaryMixin'
import OrganizationMixin from '@/mixins/organizationMixin.vue'
import FileForm from '@/components/common/files/load/load-file-form.vue'
import FileList from '@/components/common/files/load/list.vue'
import { mapMutations } from 'vuex'
import storeUtils from '@/utils/store'
import storeLabel from '@/store/labels'

export default {
  name: 'MeetingPointFrom',
  components: {
    FileForm, FileList
  },
  mixins: [validationMixin, DictionaryMixin, OrganizationMixin],
  validations: {
    meetingPoint: {
      description: { required }
    }
  },
  props: {
    metroStationList: {
      type: Array
    },
    office: {
      type: Object
    }
  },
  data: () => ({
    dictionaries: { legalFormTypeList: [] },
    meetingPoint: {
      'id': null,
      'office': {
        'id': null
      },
      'metroStationList': [],
      'description': null,
      'fileList': [],
      'coordinate': {
        'latitude': null,
        'longitude': null,
      },
    }
  }),
  computed: {
    descriptionErrors () {
      const errors = []
      if (!this.$v.meetingPoint.description.$dirty) return errors
      !this.$v.meetingPoint.description && errors.push('поле обязательно для заполнения.')
      return errors
    },
  },

  created () {
    this.eventsBus.$on(this.eventNames.MEET_POINT_FILE_LOADED, this.onFileLoaded)
    this.eventsBus.$on(this.eventNames.MEET_POINT_DELETE_FILE, this.onDeleted)
    if (this.office) {
      this.meetingPoint = {
        ...this.meetingPoint,
        ...this.office.meetingPoint,
        metroStationList: this.office.route &&
        this.office.route.metroStationList ? this.office.route.metroStationList : []
      }
    }
    this.meetingPoint.office.id = this.office.id
  },
  methods: {
    ...mapMutations({
      setFileEvents: storeUtils.setterName(storeLabel.FILE_EVENTS, storeLabel.COMMON_MODULE),
    }),
    onFileLoaded (file) {
      // this.meetingPoint.fileList.push(file)
      this.checkFiles()
      this.loadFile(file.file, this.meetingPoint, 'meeting-point')
    },
    onDeleted (index) {
      this.meetingPoint.fileList.splice(index, 1)
      this.checkFiles()
    },
    checkFiles () {
      this.showFileError = (!this.meetingPoint.fileList.length)
    },
    onPickFile (events) {
      this.setFileEvents(events)
      this.$el.querySelector(`#imageInput_${events.key}`).click()
    },
    async submit () {
      this.$v.$touch()
      this.createMeetPoint(this.meetingPoint)
    },
    clear () {
      this.$v.$reset()
      this.meetingPoint = null
    },
    removeMetroStation (deleted) {
      this.meetingPoint.metroStationList = this.meetingPoint.metroStationList.filter((item) => item.id !== deleted.id)
    },
  }
}
</script>
<style lang="scss" scoped>
    .metro-point {
      display: inline-block;
      width: 12px;
      height: 12px;
      border-radius: 50%;
    }
</style>

